export default __webpack_public_path__ + "static/media/ic-fert-organic.c9ff2759.svg";